module.exports = __webpack_public_path__ + "static/media/ControlManifest.Input.f1d81b60.xml";